import { memo, ReactElement, useRef } from 'react';
import { Vector3 } from '@react-three/fiber';
import { useEditor } from '@/hooks';

import { Mesh } from 'three';

export interface RectangleProps {
  position: Vector3;
  id: string;
  width: number;
  height: number;
  color: string;
}

const Rectangle = memo<RectangleProps>(
  ({ position, id, width, height, color }): ReactElement => {
    const meshRef = useRef<Mesh>(null);

    const { onFocusElement } = useEditor();

    return (
      <mesh
        ref={meshRef}
        position={position}
        onClick={() => onFocusElement(id, true)}>
        <planeGeometry args={[width, height]} />

        <meshStandardMaterial color={color} />
      </mesh>
    );
  },
);

export default Rectangle;
